/* export const myGetter = (state)=> { return state; } */

export const digitalLettersSearch = (state, payload) => {
    return state.digitalLetters.search
}

export const salesUsers = (state) => {
    return state.salesUsers
}

